import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  DashboardMobileSidebarTrigger,
  DashboardSidebar,
} from "../Sidebar/Sidebar";
import { SidebarInset, SidebarProvider } from "../ui/sidebar";

function Admin() {
  const location = useLocation();

  useEffect(() => {
    if (location.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      if (mainPanelRef.current) {
        mainPanelRef.current.scrollTop = 0;
      }
    }
  }, [location.action]);

  const mainPanelRef = React.createRef();

  return (
    <SidebarProvider className="dashboard-sidebar-provider">
      <DashboardSidebar />
      <SidebarInset className="dashboard-main">
        <DashboardMobileSidebarTrigger />
        <div ref={mainPanelRef} className="dashboard-app-content">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}

export default Admin;
